<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="6" vs-sm="4" vs-xs="12">
          <h3>Populate Data - Campaigns</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">
          <vs-button @click="refreshAllCampaignDatas">Populate All Data</vs-button>
        </vs-col>
      </vs-row>
      <DataGrid :context="'PopulateAdditionalSDDATA'" :rowSelection="'single'" ref="campaignsList" :columnDefs="campaignsColumnDefs" :rowData="campaignsRecords"
        :dataSource="campaignsDataSource" @openPopulateDataPopUp="openPopulateDataPopUp">
      </DataGrid>
    </vx-card>

    <vs-popup title="UnReviewed Sales Developer Data" :active.sync="UnReviewedSalesDeveloperDataPopUp">

      <div>
        <h6 class="text-center"> Listed below the campaigns which are in under reviewed. </h6>
        <h6 class="text-center"> Please review the data changes and refresh again. </h6>

      </div>
      <div>
      </div>

      <div class="vx-row p-5" v-if="unreviewed_campaigns">

        <div class="vx-col w-full">

          <div v-for="unreviewed_campaign,index in unreviewed_campaigns">


            <h6 class="ml-5">{{index + 1}} . <a class="pointer"
                @click="gotoReviewPage(unreviewed_campaign)">{{unreviewed_campaign['camp_name']}}</a></h6>
            <vs-divider class="p-1" />

          </div>
        </div>


      </div>

      <vs-row vs-w="12" v-if="refreshInBulk">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
          <vs-button @click="refreshReviewedCampaignData">Refresh</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="6" vs-sm="6" vs-xs="6">
          <vs-button @click="UnReviewedSalesDeveloperDataPopUp=false">Exit</vs-button>
        </vs-col>

      </vs-row>

    </vs-popup>




  </div>
</template>

<script>
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignFieldsManagement from "@/store/fields-management/campaign-fields-management/moduleCampaignFieldsManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import axios from "@/axios.js";
export default {
  data: () => ({
        user_id: null,
    refreshInBulk: true,
    allCampaigns: [],
    unreviewed_campaigns: [],
    UnReviewedSalesDeveloperDataPopUp: false,
    abilities: null,
    campaignsColumnDefs: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 60
      },
      {
        headerName: "Campaign",
        field: "camp_name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Code",
        field: "campaign_code",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Start Date",
        field: "start_date",
        flex: 1,

        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "End Date",
        field: "end_date",
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    campaignsRecords: [],
    selected_campaign: null
  }),
  components: {
    "v-select": vSelect,
    moduleCampaignFieldsManagement,
    DataGrid
  },
  watch: {},
  methods: {
    gotoReviewPage(campaign) {

      if (campaign) {
        this.UnReviewedSalesDeveloperDataPopUp = false
      }

      this.$router.push({
        path: "/quality_control/review_data/" + campaign.campaign_id + '/' + btoa(campaign.campaign_name)
      });

    },
    refreshReviewedCampaignData() {
      let self = this;
      self.UnReviewedSalesDeveloperDataPopUp = false
      self.$store
        .dispatch(
          "campaignsManagement/getUnReviewedCampaigns",
        )
        .then(function (response) {
          let response_data = JSON.parse(response.data);
          let all_campaigns = self.allCampaigns
          let unreviewed_campaigns = response_data

          let remaining_reviewed_campaigns = all_campaigns.filter(o1 => !unreviewed_campaigns.some(o2 => o1.campaign_id === o2.campaign_id));
          remaining_reviewed_campaigns.forEach(element => {
            self.populateAdditioanlAllData(element.campaign_id)
          });
        })



    },
    refreshAllCampaignDatas() {
      let self = this;
      self.refreshInBulk = true
      self.$store
        .dispatch(
          "campaignsManagement/getUnReviewedCampaigns",
        )
        .then(function (response) {
          let response_data = JSON.parse(response.data);
          if (response_data.length != 0) {
            self.unreviewed_campaigns = response_data


            const key = 'campaign_id';

            self.unreviewed_campaigns = [...new Map(self.unreviewed_campaigns.map(item =>
              [item[key], item])).values()];



            self.UnReviewedSalesDeveloperDataPopUp = true
          }
          else {
            self.allCampaigns.forEach(element => {
              self.populateAdditioanlAllData(element)
            });
            self.UnReviewedSalesDeveloperDataPopUp = false
          }
        })


    },
    populateAdditioanlAllData(selected_campaign) {


      console.log(selected_campaign)
      let self = this;
     self.$vs.loading();
      self.$store
        .dispatch("campaignsManagement/populateAdditionalSDData", selected_campaign.campaign_id)
        .then(res => {
          console.log(res.data)


          if (res.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Populate Data",
              text: res.data.message
            });



            var currentdate = new Date(); 
var datetime = currentdate.getFullYear() + "-"
                + (currentdate.getMonth()+1)  + "-" 
                + currentdate.getDate() + " "  
                + currentdate.getHours() + ":"  
                + currentdate.getMinutes() + ":" 
                + currentdate.getSeconds();

                // alert("Data populated successfully at " + datetime);

                

                
            
          }else{

            self.$vs.notify({
              color: "failed",
              title: "Populate Data",
              text: res.data.message
            });
            
          }

          self.$vs.loading.close();
          self.validateSDAccountDataWithMasterDB(selected_campaign)
        
        })
        .catch(err => {
          console.log(err);
        });
    },
    openPopulateDataPopUp(value) {
      let self = this;
      self.selected_campaign = value;
      self.selected_campaign_id = value.campaign_id;

      self.$store
        .dispatch(
          "campaignsManagement/getUnReviewedCampaigns",
        )
        .then(function (response) {
          let response_data = JSON.parse(response.data);
          self.unreviewed_campaigns = []
          self.refreshInBulk = false

          if(response_data.length == 0){
            self.populateAdditioanlAllData(self.selected_campaign)
              self.UnReviewedSalesDeveloperDataPopUp = false
          }else{
            response_data.forEach(element => {
            if (element.campaign_id == self.selected_campaign_id) {
              self.unreviewed_campaigns.push(element)
              self.UnReviewedSalesDeveloperDataPopUp = true
            } 

          });


             if(self.unreviewed_campaigns.length == 0){
              self.populateAdditioanlAllData(self.selected_campaign)
              self.UnReviewedSalesDeveloperDataPopUp = false
            }else{
              self.UnReviewedSalesDeveloperDataPopUp = true
            }

          }



       


        
        })


    },
    validateSDAccountDataWithMasterDB(selected_campaign) {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/validateSDAccountDataWithMasterDB", selected_campaign.campaign_id)
        .then(res => {
          if (res.data.status == "success") {

               if (res.data.data > 0) {
              let link = "/campaigns/validateSDAccountDataWithMasterDBView/" + selected_campaign.campaign_id;
              let message = 'There are ' + res.data.data + ' accounts with different values after populate data. Please review with the link below: <br> <a href ="' + window.location.origin + link + '" target="_blank"> Review Accounts</a>';

              let subject = "Populate " + selected_campaign.campaign_name + " Account Data To SD Table";

              self.sendCompletedEmail(message, subject)



            } else {

              let message = "There are no accounts with different values after populate data. Please click on the link below to view the accounts on the campaign: <br> <a href ='" + window.location.origin + "/accounts/matched/" + selected_campaign.campaign_id + '/' + btoa(selected_campaign.campaign_name) + "' target='_blank'>View Campaign Accounts</a>";

              let subject = "Populate " + selected_campaign.campaign_name + " Account Data To SD Table";

              self.sendCompletedEmail(message, subject)


            }


              self.validateAccountClientViewDataWithMasterDB(selected_campaign)
       
           
            
          }
          else{

             let message = 'There is something wrong with the update. Please contact support team.';

              let subject = "Populate " + selected_campaign.campaign_name + " Account Data To SD Table";

              self.sendCompletedEmail(message, subject)



          }
        })
        .catch(err => {     
          console.log(err);     
            });
          },
           validateAccountClientViewDataWithMasterDB(selected_campaign) {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/validateAccountClientViewDataWithMasterDB", selected_campaign.campaign_id)
        .then(res => {
          if (res.data.status == "success") {

               if (res.data.data > 0) {
              let link = "/campaigns/validateClientViewAccountDataWithMasterDBView/" + selected_campaign.campaign_id;
              let message = 'There are ' + res.data.data + ' accounts with different values after populate data. Please review with the link below: <br> <a href ="' + window.location.origin + link + '" target="_blank"> Review Accounts</a>';

              let subject = "Populate " + selected_campaign.campaign_name + " Account Data To Client View Table";

              self.sendCompletedEmail(message, subject)



            } else {

              let message = "There are no accounts with different values after populate data. Please click on the link below to view the accounts on the campaign: <br> <a href ='" + window.location.origin + "/accounts/matched/" + selected_campaign.campaign_id + '/' + btoa(selected_campaign.campaign_name) + "' target='_blank'>View Campaign Accounts</a>";

              let subject = "Populate " + selected_campaign.campaign_name + " Account Data To Client View Table";

              self.sendCompletedEmail(message, subject)


            }

              self.validateSDContactDataWithMasterDB(selected_campaign)

           
            
          }
          else{

             let message = 'There is something wrong with the update. Please contact support team.';

              let subject = "Populate " + selected_campaign.campaign_name + " Account Data";

              self.sendCompletedEmail(message, subject)



          }
        })
        .catch(err => {     
          console.log(err);     
            });
          },
           validateSDContactDataWithMasterDB(selected_campaign) {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/validateSDContactDataWithMasterDB", selected_campaign.campaign_id)
        .then(res => {
          if (res.data.status == "success") {

               if (res.data.data > 0) {
              let link = "/campaigns/validateSDContactDataWithMasterDBView/" + selected_campaign.campaign_id;
              let message = 'There are ' + res.data.data + ' contacts with different values after populate data. Please review with the link below: <br> <a href ="' + window.location.origin + link + '" target="_blank"> Review Contacts</a>';

              let subject = "Populate " + selected_campaign.campaign_name + " Contact Data To SD Table";

              self.sendCompletedEmail(message, subject)



            } else {

              let message = "There are no contacts with different values after populate data. Please click on the link below to view the contacts on the campaign: <br> <a href ='" + window.location.origin + "/accounts/matched/" + selected_campaign.campaign_id + '/' + btoa(selected_campaign.campaign_name) + "' target='_blank'>View Campaign Contacts</a>";

              let subject = "Populate " + selected_campaign.campaign_name + " Contact Data To SD Table";

              self.sendCompletedEmail(message, subject)


            }

                      self.validateContactClientViewDataWithMasterDB(selected_campaign)


           
            
          }
          else{

             let message = 'There is something wrong with the update. Please contact support team.';

              let subject = "Populate " + selected_campaign.campaign_name + " Contact Data";

              self.sendCompletedEmail(message, subject)



          }
        })
        .catch(err => {     
          console.log(err);     
            });
          },
           validateContactClientViewDataWithMasterDB(selected_campaign) {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/validateContactClientViewDataWithMasterDB", selected_campaign.campaign_id)
        .then(res => {
          if (res.data.status == "success") {

               if (res.data.data > 0) {
              let link = "/campaigns/validateClientViewContactDataWithMasterDBView/" + selected_campaign.campaign_id;
              let message = 'There are ' + res.data.data + ' contacts with different values after populate data. Please review with the link below: <br> <a href ="' + window.location.origin + link + '" target="_blank"> Review Contacts</a>';

              let subject = "Populate " + selected_campaign.campaign_name + " Contact Data To Client View Table";

              self.sendCompletedEmail(message, subject)



            } else {

              let message = "There are no contacts with different values after populate data. Please click on the link below to view the contacts on the campaign: <br> <a href ='" + window.location.origin + "/accounts/matched/" + selected_campaign.campaign_id + '/' + btoa(selected_campaign.campaign_name) + "' target='_blank'>View Campaign Contacts</a>";

              let subject = "Populate " + selected_campaign.campaign_name + " Contact Data To Client View Table";

            self.sendCompletedEmail(message, subject)


            }

           
            
          }
          else{

             let message = 'There is something wrong with the update. Please contact support team.';

              let subject = "Populate " + selected_campaign.campaign_name + " Contact Data To Client View Table";

              self.sendCompletedEmail(message, subject)



          }
        })
        .catch(err => {     
          console.log(err);     
            });
          },

    sendCompletedEmail(message , subject){

       let self = this
        let data = {}
        data.user_id = self.user_id
        data.message = message
        data.subject = subject
        axios
        .post(
          self.$base_url + "/api/contacts/send_completed_email",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Data Validation",
              text: "The data validation email has been sent successfully."
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
        
    },
    getcampaignDataSource() {
      var self = this;

      this.campaignsDataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "campaignsManagement/getAllCampaignsForGridForPopulateData",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;
              self.allCampaigns = response_data
              console.log("Campaigns", response_data);
              if (response_data.length != 0) {
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.getcampaignDataSource();
  },
  mounted() { 
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
     let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    if (!moduleCampaignFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "CampaignFieldsManagement",
        moduleCampaignFieldsManagement
      );
      moduleCampaignFieldsManagement.isRegistered = true;
    }
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
